import { useTranslation } from 'next-i18next';

import { useAppSelector } from 'src/app/hooks';
import { selectCurrentContact } from 'slices/contactsSlice';
import { formatMoney } from 'src/features/proformaInvoices/InvoiceDrawer/InvoicePayments/formatMoney';
import Section from '../Section';
import useContactPaymentTotals from './useContactPaymentTotals';
import styles from './PaymentTotals.module.css';

export default function PaymentTotals() {
  const {
    t,
    i18n: { language },
  } = useTranslation('contact-details');
  const currentContact = useAppSelector(selectCurrentContact);
  const totals = useContactPaymentTotals(currentContact.uuid);

  if (totals.length === 0) {
    return null;
  }

  return (
    <Section
      title={t('payments.title')}
      entityName=""
      onClickCreate={() => undefined}
      withButton={false}
    >
      {() => (
        <ul className={styles.list}>
          {totals.map(({ currency, paymentsReceived, totalContractValue }) => (
            <li key={currency} className={styles.row}>
              <dl className={styles.values}>
                <dt>{t('payments.received')}</dt>
                <dd>{formatMoney(paymentsReceived, currency, language)}</dd>
                <dt>{t('payments.contractValue')}</dt>
                <dd>{formatMoney(totalContractValue, currency, language)}</dd>
              </dl>
            </li>
          ))}
        </ul>
      )}
    </Section>
  );
}
